import React, { useState, useEffect } from "react";
import "./choosePlan.css";

import step1 from "assets/choosePlan-image/icon_step1_choose_plan_active.svg";
import step2 from "assets/choosePlan-image/icon_step2_choose_plan.svg";
import step3 from "assets/choosePlan-image/icon_step3_choose_plan.svg";
import { useNavigate } from "react-router-dom";

// API
import { getQuery } from "api";
import { API_CHOOSE_PLAN } from "utils/apiEndPoints";
import Meta from "utils/meta";
import PricingHeader from "../../Component/PricingHeader/pricingHeader";

const ChoosePlan = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [billingCycle, setBillingCycle] = useState('monthly');

  const handleGetStart = (packageDetails) => {
    navigate("/registration", {
      state: { package_id: packageDetails.id },
    });
  };

  const refresh = async () => {
    try {
      let currentPlans = plans;
      if(plans.length <= 0) {
        const response = await getQuery(API_CHOOSE_PLAN);
        if (response?.data?.success === 1) {
          setPlans(response?.data?.data?.package);
          currentPlans = response?.data?.data?.package;
        }
      }
      const filteredPlans = currentPlans.filter((plan) => {
        if (billingCycle === "monthly") {
          return plan.billing_frequency === "monthly";
        } else {
          return plan.billing_frequency === "yearly";
        }
      });
      setSelectedPlan(filteredPlans);
    } catch (error) {
      return console.log("error", error);
    }
  };

  useEffect(() => {
    refresh();
  }, [billingCycle]);

  const handleSwitch = (cycle) => {
    setBillingCycle(cycle);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container">
      <Meta title="Choose Plan | The Realtor Desk" description="" />
      <div className="choosePlan-container">
        <PricingHeader
            title="Register your account with us, it's free"
            subTitle="Choose your personal plan"
            step1={step1}
            step2={step2}
            step3={step3}
            isLine1Active={false}
            isLine2Active={false}
        />
        <div className="plan-switcher">
          <button onClick={() => handleSwitch('monthly')} className={`switch-button ${billingCycle === 'monthly' ? 'active' : ''}`}>
            Monthly
          </button>
          <button onClick={() => handleSwitch('yearly')} className={`switch-button ${billingCycle === 'yearly' ? 'active' : ''}`}>
            Yearly
          </button>
        </div>
        <div className="choosePlan-row">
          {selectedPlan.map((packages) => (
            <div className="choosePlan-box" key={packages.id}>
              <h3>{packages.name}</h3>
              <h2>
                ₹{packages.billing_amount}
                <span>/ {packages.billing_frequency}</span>
              </h2>
              <p>{packages.no_of_users} Users</p>
              <p>
                {[
                  packages.access_sales_module && "Sale",
                  packages.access_marketing_module && "Marketing",
                  packages.access_finance_module && "Finance",
                ]
                  .filter(Boolean)
                  .join(", ")}{" "}
              </p>
              <p>{packages.description}</p>
              <button
                onClick={() => handleGetStart(packages)}
                className="choosePlan-start-btn"
              >
                Get Start
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChoosePlan;
